let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dQaGo")).then(() => parcelRequire('fyq5j'));